import { toCapitalizedCase } from '@utils/commonUtils';

/**
 * Remove <br> at the beginning and end of the string
 * @param {string} str
 * @returns {string}
 */
export function trimBrTags(str = '') {
  return str.replace(/^(<br\s*\/?>)+|(<br\s*\/?>)+$/g, '').trim();
}

/**
 *
 * @typedef {Object} Column
 * @property {string} title
 * @property {string} paragraph
 * @property {boolean} isAvailable
 *
 * @param {string} input
 * @param {RegExp} regExp
 * @param {boolean} isComplexDescription
 * @returns {Column[]}
 */
export function splitTextToColumns(input = '', regExp, isComplexDescription) {
  const result = [];
  let match;
  let lastIndex = 0;

  while (true) {
    match = regExp.exec(input);

    if (match === null) break;

    if (result.length > 0 && lastIndex < match.index) {
      let paragraph = input.slice(lastIndex, match.index).trim();
      paragraph = trimBrTags(paragraph);
      result[result.length - 1].paragraph = paragraph;
      result[result.length - 1].isAvailable = paragraph !== '';
    }

    if (isComplexDescription) {
      if (result.length === 0 && match.index) {
        const paragraph = trimBrTags(input.slice(0, match.index));
        result.push({
          title: '',
          paragraph,
          isAvailable: paragraph !== '',
        });
      }
    }

    result.push({
      title: toCapitalizedCase(match[1].trim()),
      paragraph: '',
      isAvailable: false,
    });

    lastIndex = regExp.lastIndex;
  }

  if (lastIndex < input.length && result.length > 0) {
    let paragraph = input.slice(lastIndex).trim();
    paragraph = trimBrTags(paragraph);
    result[result.length - 1].paragraph = paragraph;
    result[result.length - 1].isAvailable = paragraph !== '';
  }

  return result;
}

export default {
  trimBrTags,
  splitTextToColumns,
};
